export default __webpack_public_path__ + "static/contact-bg-57bef7c5239e251bacc2ad8731447376.jpg";